import { render, staticRenderFns } from "./shop-list.vue?vue&type=template&id=bf910d32&scoped=true"
import script from "./shop-list.vue?vue&type=script&lang=js"
export * from "./shop-list.vue?vue&type=script&lang=js"
import style0 from "./shop-list.vue?vue&type=style&index=0&id=bf910d32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf910d32",
  null
  
)

export default component.exports